var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel-content',{staticClass:"r-col rounded-0 panel-bar-parent mb-n4",attrs:{"eager":""}},[_c('v-system-bar',{staticClass:"mx-n10",attrs:{"height":"5","color":"accent"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }